// Old page addresses that the live (Drupal) site redirects to a page's current address.
// Page bodies and outside links still use them, so they are sent on the same way here.
// Keys and values are paths without the leading slash.
export const PAGE_REDIRECTS = {
  'content/hockey-analytics': 'courses/hockey-analytics',
  'courses/athlete-management-sports-agent/salaries': 'program/salaries',
  'courses/digital-video-editing': 'courses/football-video-performance-analysis-catapult',
  'courses/digital-video-editing-synergy': 'courses/basketball-video-performance-analysis-synergy',
  'courses/soccer-management': 'courses/soccer-scouting',
  'courses/sports-betting': 'courses/sports-cryptocurrency',
  'courses/sports-marketing-communications': 'courses/sports-media-content-strategy',
  'courses/sports-product-marketing': 'courses/athletic-design-manufacturing',
  'courses/sports-revenue-management': 'courses',
  'mixed-martial-arts-course': 'courses/mixed-martial-arts-course',
};
